import ActivityParticipants from './activity-participants-container'

export default ActivityParticipants
